export default "__VITE_ASSET__BwrCwxCp__"